export const localdata = {
  GET_DATA: () => {
    const json = localStorage.getItem('account');
    const savedUser = JSON.parse(json);
    return savedUser;
  },
};
